<template>
  <div class="container mb-4 mt-4">
    <form @input.once="isFormEdited = true">
      <div class="row">
        <base-input class="form-group col-md-6" v-model.trim="formData.firstName" type="text"
                    :placeholder="$t('PLACEHOLDER.FirstName')" :error="errors.first_name"/>
        <base-input class="form-group col-md-6" v-model.trim="formData.lastName" type="text"
                    :placeholder="$t('PLACEHOLDER.LastName')" :error="errors.last_name"/>
      </div>
      <custom-form-component ref="customForm" :customFormClasses="customFormClasses"
                             :customFieldClasses="customFieldClasses"/>
      <div class="row">
        <base-input class="form-group col-md-4" :value="user && user.email" disabled type="text"/>
        <base-input class="form-group col-md-4" v-model.trim="formData.password" type="password"
                    isPassword="true" :placeholder="$t('PLACEHOLDER.NewPass')"
                    :error="errors.password"/>
        <base-input class="form-group col-md-4" v-model.trim="formData.passwordConfirmation"
                    type="password" isPassword="true" :placeholder="$t('PLACEHOLDER.ConfirmPass')"
                    :error="errors.password"/>
      </div>
      <button @click.stop.prevent="updateProfile"
              class="w-100 btn btn-block btn-dark"
              :disabled="!isFormEdited"
      >
        {{ $t('Update') }}
      </button>
    </form>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex';
import CustomFormComponent from '../CustomFormComponent';
import BaseInput from '../base-components/BaseInput';
import {DO_UPDATE_PROFILE} from '@/store/actionTypes';
import {ACTIVE_ORDERS} from '@/pages';

export default {
  name: 'UpdateProfileComponent',
  components: {CustomFormComponent, BaseInput},
  data() {
    return {
      loading: false,
      additionalParamsToErrormessage: null,
      checked: false,
      formData: {
        firstName: '',
        lastName: '',
        password: '',
        passwordConfirmation: '',
      },
      errors: {
        first_name: '',
        last_name: '',
        password: '',
      },
      customFormClasses: ['row'],
      customFieldClasses: ['col-md-6'],
      isFormEdited: false,
    };
  },
  methods: {
    ...mapActions({doUpdateProfile: DO_UPDATE_PROFILE}),
    updateProfile() {
      this.clearErrors();
      if (!this.validateInputs()) {
        return;
      }
      this.loading = true;
      const data = {
        first_name: this.formData.firstName,
        last_name: this.formData.lastName,
        password: this.formData.password,
        password_confirmation: this.formData.passwordConfirmation,
      };
      const customFields = Object.entries(this.$refs.customForm.getFieldsData())
          .reduce((acc, [key, value]) => {
            if (value) acc[key] = value;
            return acc;
          }, {});

      if (customFields.phone) {
        customFields.phone = customFields.phone.replace(/\D/g, '');
        if (!customFields.phone.length) {
          delete customFields.phone;
        }
      }
      Object.assign(data, customFields);
      this.doUpdateProfile(data).then(() => {
        this.$refs.customForm.getCustomFormData(this.$refs.customForm.alias);
        this.loading = false;
        this.clearErrors();
        this.$router.push(ACTIVE_ORDERS);
      }).catch((data) => {
        this.loading = false;
        if (data?.errors) {
          for (const field in data.errors) {
            if (data.errors[field]) {
              for (const error of data.errors[field]) {
                this.errors[field] = error.message;
              }
            }
          }
        }
      });
    },
    validateCustomInputs() {
      return this.$refs.customForm.validate();
    },
    validateInputs() {
      const customValidate = this.validateCustomInputs();
      this.errors.first_name = !this.formData.firstName && 'ERRORS.firstName';
      this.errors.last_name = !this.formData.lastName && 'ERRORS.lastName';
      if (this.formData.password || this.formData.passwordConfirmation) {
        if (this.formData.password !== this.formData.passwordConfirmation) {
          this.errors.password = 'ERRORS.passwordMatch';
        } else {
          this.errors.password = (this.formData.password.length < 8) && 'ERRORS.passwordShort';
        }
      }
      for (const error in this.errors) {
        if (this.errors[error]) {
          return false;
        }
      }
      return customValidate;
    },
    clearErrors() {
      for (const error in this.errors) {
        if (error) {
          this.errors[error] = '';
        }
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  mounted() {
    this.formData.firstName = this.user?.first_name;
    this.formData.lastName = this.user?.last_name;
  },
};
</script>
